







































import Vue from "vue";
import { Data, Methods, Props } from "./ForeignSalePriceGuideType";
import { ABBREVIATION_THRESHOLD_WIDTH } from "./ForeignSalePriceGuideConst";

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    discountRateText: { default: undefined },
    guideText: { default: undefined },
    originalPriceText: { default: undefined },
    salePriceText: { default: undefined }
  },
  data() {
    return {
      isAbbreviationStyle: false
    };
  },
  mounted() {
    this.updateIsAbbreviationStyle();
    window.addEventListener("resize", this.updateIsAbbreviationStyle);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsAbbreviationStyle);
  },
  methods: {
    updateIsAbbreviationStyle() {
      const windowWidth = document.documentElement.clientWidth;
      this.isAbbreviationStyle = ABBREVIATION_THRESHOLD_WIDTH > windowWidth;
    }
  }
});
